






































































































































































































import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { Case } from '@/modules/Case/interfaces/case'
import { AccountAsset, AccountAssetType } from '@/modules/Account/interfaces/account-asset'
import CaseFoldingCard from '@/modules/Newcase/components/CaseFoldingCard.vue'
import dollarFilter from '@/utils/dollarFilter'
import { dateToDisplay, dateTimeToDisplay } from '@/utils/dateTime'
import AssetVehicleDialog from '@/modules/AccountAsset/scripts/asset-vehicle-dialog'
import AssetPropertyDialog from '@/modules/AccountAsset/scripts/asset-property-dialog'
import { getAccountAssets } from '@/modules/Account/gql/account.gql'
import { showErrors } from '@/utils/snack'
import { CaseReview } from '@/modules/Newcase/interfaces/case-review'
import { addAssetToCase, removeAssetFromCase } from '@/modules/Newcase/gql/case.gql'

@Component({
  components: {
    CaseFoldingCard
  }
})
export default class AccountAssets extends mixins(AssetVehicleDialog, AssetPropertyDialog) {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
  @Prop({ type: Boolean, default: true }) readonly editable!: Boolean
  @Prop({ type: Boolean }) readonly unFolding!: boolean
  @Prop({ type: Boolean }) readonly ifReview!: boolean
  @Prop({ type: Object as () => CaseReview }) readonly review!: CaseReview

  assets: AccountAsset[] = []
  properties: AccountAsset[] = []
  vehicles: AccountAsset[] = []

  subTitle: {
    property: string
    vehicle: string
  } = {
    property: '',
    vehicle: ''
  }
  warning: boolean = false

  propertyTableColumn = [
    { field: '', title: '', slots: { default: 'select_default' }, width: 60, resizable: true },
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'address',
      title: 'Address',
      slots: { default: 'address' },
      resizable: true
    },
    { field: 'city',
      title: 'City',
      slots: { default: 'city' },
      width: 100,
      resizable: true
    },
    { field: 'state',
      title: 'State',
      slots: { default: 'state' },
      width: 100,
      resizable: true
    },
    { field: 'zipCode',
      title: 'Zip Code',
      slots: { default: 'zipCode' },
      width: 100,
      resizable: true
    },
    { field: 'country',
      title: 'Country',
      slots: { default: 'country' },
      width: 100,
      resizable: true
    },
    { field: 'owner',
      title: 'Owner',
      slots: { default: 'owner' },
      width: 150,
      resizable: true
    },
    { field: 'price',
      title: 'Price',
      slots: { default: 'price' },
      width: 120,
      resizable: true
    },
    { field: 'creationTime',
      title: 'Creation Time',
      slots: { default: 'creationTime' },
      width: 130,
      resizable: true
    },
    { field: 'buyTime',
      title: 'Buy Time',
      slots: { default: 'buyTime' },
      width: 130,
      resizable: true
    }
    // { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  vehicleTableColumn = [
    { field: '', title: '', slots: { default: 'select_default' }, width: 60, resizable: true },
    { field: 'name',
      title: 'Name',
      slots: { default: 'name' },
      width: 200,
      resizable: true
    },
    { field: 'vid',
      title: 'VIN',
      slots: { default: 'vid' },
      width: 100,
      resizable: true
    },
    { field: 'brand',
      title: 'Brand',
      slots: { default: 'brand' },
      width: 200,
      resizable: true
    },
    { field: 'color',
      title: 'Color',
      slots: { default: 'color' },
      width: 100,
      resizable: true
    },
    { field: 'type',
      title: 'Vehicle Type',
      slots: { default: 'type' },
      minWidth: 150,
      resizable: true
    },

    { field: 'price',
      title: 'Price',
      slots: { default: 'price' },
      width: 220,
      resizable: true
    },
    { field: 'owner',
      title: 'Owner',
      slots: { default: 'owner' },
      width: 220,
      resizable: true
    },
    {
      field: 'makeModel',
      title: 'Model',
      slots: { default: 'owner' },
      width: 220,
      resizable: true
    },
    {
      field: 'year',
      title: 'Year',
      slots: { default: 'owner' },
      width: 220,
      resizable: true
    }
    // { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  selectedPropertyIndex = 0
  propertyId = -1

  dateToDisplay = dateToDisplay
  dateTimeToDisplay = dateTimeToDisplay
  dollarFilter = dollarFilter

  get accountId () {
    return +this.caseInfo.account.id
  }

  get assetCardTitle () {
    return `Assets (${this.assets.length})`
  }

  mounted () {
    this.getAssets()
  }

  @Watch('caseInfo')
  onCaseInfoChanged (val: Case) {
    this.getAssets()
  }

  @Watch('selectedPropertyIndex')
  async onSelectedPropertyIndexChanged (val: number) {
    const item = this.properties[val] || this.vehicles[val]
    const { asset } = this.caseInfo
    if (asset && asset.property) {
      if (item && (!asset || +asset.property.id !== +item.id)) {
        await this.addAssetToCase(+item.id)
        this.refreshCase()
      }
    }
    if (asset && asset.vehicle) {
      if (item && (!asset || +asset.vehicle.id !== +item.id)) {
        await this.addAssetToCase(+item.id)
        this.refreshCase()
      }
    }
    if (!asset && item) {
      await this.addAssetToCase(+item.id)
      this.refreshCase()
    }
  }

  @Emit('success')
  async refreshCase () {
  }

  @Emit('success')
  async onPropertySuccess (id: number) {
    const { targetAccountAsset, caseInfo: { asset } } = this
    this.hidePropertyEditDialog()
    if (!targetAccountAsset && !asset) {
      await this.addAssetToCase(+id)
    }

    this.getAssets()
    return id
  }

  @Emit('success')
  onVehicleSuccess (id: number) {
    this.hideVehicleEditDialog()
    this.getAssets()
    return id
  }

  async getAssets () {
    if (!this.caseInfo) {
      return
    }
    try {
      const result = await this.$apollo.query({
        query: getAccountAssets,
        variables: {
          accountId: +this.caseInfo.account.id,
          order: {
            orderBy: 'UPDATED_AT'
          },
          filter: {}
        }
      })
      this.assets = result.data.getAccountAssets.accountAssets
      if (this.caseInfo.recordType.name === 'Personal Auto') {
        this.assets = this.assets.filter(item => item.type === AccountAssetType.VEHICLE)
      }
      if (this.caseInfo.recordType.name === 'Homeowners') {
        this.assets = this.assets.filter(item => item.type === AccountAssetType.PROPERTY)
      }
      const properties = []
      const vehicles = []
      for (const asset of this.assets) {
        if (asset.type === AccountAssetType.PROPERTY) {
          properties.push(asset)
        } else {
          vehicles.push(asset)
        }
      }

      const { asset } = this.caseInfo

      if (!asset) {
        this.selectedPropertyIndex = -1
        this.subTitle.property = ''
        this.warning = true
      } else {
        const idx = this.assets.findIndex((item) => +item.id === +asset.id)
        const content = this.assets[idx]
        if (content) {
          if (content.type === AccountAssetType.PROPERTY) {
            this.subTitle.property = content.name
            this.selectedPropertyIndex = properties.findIndex(item => item.id === content.id)
          } else {
            this.subTitle.vehicle = content.name
            this.selectedPropertyIndex = vehicles.findIndex(item => item.id === content.id)
          }
          this.warning = false
        } else {
          this.warning = true
          this.subTitle.property = ''
        }
      }
      this.properties = [...properties]
      this.vehicles = [...vehicles]
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  newProperty (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showPropertyEditDialog(e)
  }

  newVehicle (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showVehicleEditDialog(e)
  }

  handleDeleteVehicle (e: Event, accountAsset: AccountAsset) {
    e.preventDefault()
    e.stopPropagation()
    this.targetAccountAsset = accountAsset
    this.deleteVehicleDialog.show = true
  }

  handleDeleteProperty (e: Event, accountAsset: AccountAsset) {
    e.preventDefault()
    e.stopPropagation()
    this.targetAccountAsset = accountAsset
    this.deletePropertyDialog.show = true
  }

  async deletePropertyConfirm () {
    if (!this.targetAccountAsset) {
      return
    }

    if (+this.targetAccountAsset.id === +this.properties[this.selectedPropertyIndex].id) {
      await this.removeCaseProperty(+this.targetAccountAsset.id)
    }
    await this.deletePropertyPost()
    this.deletePropertyDialog.show = false
    this.refreshCase()
    this.getAssets()
  }

  async deleteVehicleConfirm () {
    if (!this.targetAccountAsset) {
      return
    }
    await this.deletePropertyPost()
    this.deleteVehicleDialog.show = false
    this.refreshCase()
    this.getAssets()
  }

  selectProperty (index: number) {
    this.selectedPropertyIndex = index
    this.subTitle.property = this.properties[index].name
  }

  selectVehicle (index: number) {
    this.selectedPropertyIndex = index
    this.subTitle.vehicle = this.vehicles[index].name
  }

  async removeCaseProperty (assetId: number) {
    if (!this.caseInfo) {
      return
    }
    try {
      const result = await this.$apollo.mutate({
        mutation: removeAssetFromCase,
        variables: {
          caseId: Number(this.caseInfo.id)
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async addAssetToCase (assetId: number) {
    if (!this.caseInfo) {
      return
    }
    try {
      const result = await this.$apollo.mutate({
        mutation: addAssetToCase,
        variables: {
          caseId: Number(this.caseInfo.id),
          assetId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
